export default __webpack_public_path__ + "static/media/warning--width-restriction--g3.8a82e40c.png";